<script>
    import Router from './components/Router/index.svelte';
    import Home from './pages/Home.svelte';
    import About from './pages/About.svelte';
    import Numbers from './pages/Numbers.svelte';
	
	import './utils/firebase';

    const routes = new Map()
        .set('/', () => Home)
		.set('/about', () => About)
        .set('\/-?([0-9]+(\.[0-9]+)?)', () => Numbers);
</script>

<Router {routes} />

<style global lang="postcss">
@tailwind base;
@tailwind components;
@tailwind utilities;
    
html, body {
	position: relative;
	width: 100%;
	height: 100%;
}

h1 {
    font-size: 225%;
    font-weight: bold;
}

h2 {
    font-size: 155%;
    font-weight: bold;
}

h3 {
    font-size: 127%;
    font-weight: 500;
}

h4 {
	font-size: 83%;
	font-weight: 400;
}

ul {
    list-style-type: disc;
}

.fa-svelte {
	vertical-align: middle;
}

.hoverable:hover {
	color: rgb(77, 77, 77);
	cursor: pointer;
}

body {
	color: #333;
	margin: 0;
	padding: 0px;
	box-sizing: border-box;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}

a.as-text:not(.btn) {
	color: #014386;
}

a:not(.btn) {
	color: rgb(0, 100, 200);
	text-decoration: none;
}

a:hover:not(.btn > a) {
	text-decoration: underline;
}

a:visited:not(.btn > a) {
	color: rgb(0,80,160);
}

label {
	display: block;
}

input, button, select, textarea {
	font-family: inherit;
	font-size: inherit;
	-webkit-padding: 0.4em 0;
	padding: 0.4em;
	margin: 0 0 0.5em 0;
	box-sizing: border-box;
	border: 1px solid #ccc;
	border-radius: 2px;
}

input:disabled {
	color: #ccc;
}

button {
	color: #333;
	background-color: #f4f4f4;
	outline: none;
}

button:disabled {
	color: #999;
}

button:not(:disabled):active {
	background-color: #ddd;
}

button:focus {
	border-color: #666;
}

</style>